import { Link } from '@tbitop/mobile-app';
import { Badge, Card, Header4, Paragraph, Subheader } from '@tbitop/ui';
import { isNull } from 'lodash-es';
import { useId } from 'react';
import { countAbgeschlosseneAufgaben, countAllOffenOrAbgeschlosseneAufgaben, countOffeneAufgaben } from '../../../infrastructure/graphql';
import type { Objekt, ObjektAdresse } from './objekt-list-types';


export type ObjektListItemProps = {
  objekt: Objekt;
};

export const ObjektListItem = ({ objekt }: ObjektListItemProps) => {
  const id = useId();

  return (
    <li aria-labelledby={id} className="mt-100 first:mt-0">
      <Link href={`/objekte/${objekt.id}`}>
        <Card displayAsClickable>
          <div className="mb-200 grid grid-cols-[1fr_0fr] grid-rows-1">
            <div className="text-tds-color-copy-on-light-10">
              <Header4 id={id}>{objekt.name}</Header4>
              <Subheader>{objekt.name2}</Subheader>
              <Subheader>{objekt.nummer}</Subheader>
            </div>
            <ObjektAufgabenCounter objekt={objekt} className=""/>
          </div>
          <ObjektAdresseParagraph adresse={objekt.adresse} />
        </Card>
      </Link>
    </li>
  );
};

export type ObjektAdresseProps = {
  adresse: ObjektAdresse | null;
};

const ObjektAdresseParagraph = ({ adresse }: ObjektAdresseProps) => {
  if (isNull(adresse)) {
    return null;
  }
  return (
    <address className="not-italic text-tds-color-copy-on-light-50">
      <Paragraph>{adresse.strasse}, {adresse.postleitzahl} {adresse.ort}</Paragraph>
    </address>
  );
};


type ObjektAufgabenCounterProps = {
  objekt: Objekt;
  className?: string;
};

const ObjektAufgabenCounter = ({ objekt, className }: ObjektAufgabenCounterProps) => {
  const offen = countOffeneAufgaben(objekt);
  const geschlossen = countAbgeschlosseneAufgaben(objekt);
  const allOffenOrAbgeschlossen = countAllOffenOrAbgeschlosseneAufgaben(objekt);
  const alleAufgabenAbgeschlossen = geschlossen === allOffenOrAbgeschlossen;

  if (alleAufgabenAbgeschlossen) {
    return null;
  }

  return (
    <Badge className={className} amount={offen} srText={`offene Aufgabe${offen === 1 ? '' : 'n'}}`}/>
  );
};

